import { ChangeDetectionStrategy, Component, effect, input, output } from '@angular/core';

import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule, TooltipPosition } from '@angular/material/tooltip';
import { MatMenuModule } from "@angular/material/menu";
import { MatButtonModule } from '@angular/material/button';
import { ISensitivityLabel } from '../../interfaces/i-sensitivity-label';
import { SENSITIVITY_LABELS_FLAT } from '../../constants/sensitivity.constants';

@Component({
  selector: 'sensitivity-labels',
  standalone: true,
  imports: [
    MatIconModule,
    MatTooltipModule,
    MatMenuModule,
    MatButtonModule
],
  templateUrl: './sensitivity-labels.component.html',
  styleUrl: './sensitivity-labels.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class SensitivityLabelsComponent {
  // Tool tip position for the button only.  Not the sub-menus.
  btnTooltipPosition = input<TooltipPosition>('above');
  label = input<ISensitivityLabel | null>({ id: 2, label: "Public", guid: '07e7d3fe-b7dd-4475-ad09-6a65728f76cb' });
  labelSelected = output<ISensitivityLabel>();
  sensitivityLabel: ISensitivityLabel = { id: 2, label: "Public", guid: '07e7d3fe-b7dd-4475-ad09-6a65728f76cb' };

  constructor() {
    effect(() => {
      const l = this.label();
      if (l) {
        this.sensitivityLabel = l;
      }
    });
  }

  /**
   * Gets the selected sensitivity label.
   * @param option
   */
  onSelectSensitivity(option: number) {
    this.sensitivityLabel = SENSITIVITY_LABELS_FLAT.find(item => item.id === option)!;
    this.labelSelected.emit(this.sensitivityLabel);
  }

}
